const PERSON_FISCAL_CODE_PATTERN =
  /^[A-Z]{6}[0-9LMNP-V]{2}[A-EHLMPR-T][0-9LMNP-V]{2}[A-Z][0-9LMNP-V]{3}[A-Z]$/;

const ODD_POSITION_VALUES = Object.freeze({
  0: 1,
  1: 0,
  2: 5,
  3: 7,
  4: 9,
  5: 13,
  6: 15,
  7: 17,
  8: 19,
  9: 21,
  A: 1,
  B: 0,
  C: 5,
  D: 7,
  E: 9,
  F: 13,
  G: 15,
  H: 17,
  I: 19,
  J: 21,
  K: 2,
  L: 4,
  M: 18,
  N: 20,
  O: 11,
  P: 3,
  Q: 6,
  R: 8,
  S: 12,
  T: 14,
  U: 16,
  V: 10,
  W: 22,
  X: 25,
  Y: 24,
  Z: 23,
});

function evenPositionValue(character) {
  return /\d/.test(character)
    ? Number(character)
    : character.charCodeAt(0) - "A".charCodeAt(0);
}

function hasValidPersonChecksum(code) {
  const total = code
    .slice(0, 15)
    .split("")
    .reduce(
      (sum, character, index) =>
        sum +
        (index % 2 === 0
          ? ODD_POSITION_VALUES[character]
          : evenPositionValue(character)),
      0
    );

  return code[15] === String.fromCharCode("A".charCodeAt(0) + (total % 26));
}

export function validFiscalCode(value) {
  const code = String(value || "")
    .trim()
    .toUpperCase();

  if (/^\d{11}$/.test(code)) return true;
  return PERSON_FISCAL_CODE_PATTERN.test(code) && hasValidPersonChecksum(code);
}
